module.exports = __webpack_public_path__ + "1cd0f3d8abb6f34cbffc490c6f2d44a0.woff2";